.container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 10px;
  --slide-distance: 20%;
  composes: slideRight from global;
}

.cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 1rem;
  padding-bottom: 8px;
}

.card {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  padding: 16px;
  max-width: 300px;
  text-align: center;
  background-color: #fff;
  border-radius: 2px;
  border: 1px solid #d5d5d5;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}
.card:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 1);
  transform: scale(1.05);
}

.cardHeader {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.secondaryHeader {
  border-bottom: 1px solid #d9d9d9;
}

.description {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 10px;
  font-size: 16px;
  font-family: Gantari;
  font-weight: 400;
  text-align: left;
}

.message {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 10px;
  font-size: 14px;
  font-family: Gantari;
  font-weight: 400;
  text-align: left;
  align-self: flex-start;
  max-width: 250px;
}

.sequenceContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  border-bottom: 1px solid #d9d9d9;
}

.sequenceInput {
  width: 100px;
  text-align: right;
}

.buttons {
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
}

.iconButton {
  min-height: 32px;
  min-width: 32px;
  padding: 4px;
}

.statusSwitch {
  height: 25px;
}

.disabled {
  background-color: var(--app-background-color);
  border-color: #fb4f4f;
}

.cardContent {
  margin-top: 10px;
  width: 100%;
}

.fieldRow {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
  border-bottom: 1px solid #d9d9d9;
}

.fieldLabel {
  color: #595959;
}

.fieldValue {
  text-align: right;
}

.footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 1rem;
  font-size: 14px;
  color: #595959;
}

.itemsPerPage {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 175px;
}

.itemsPerPageSelectContainer {
  height: 47px;
  margin-left: 8px;
}

.itemsPerPageSelect {
  font-size: 14px;
  color: #595959;
  width: 50px;
  padding: 0px;
  border: none;
  background-color: transparent;
}

.pageInfo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
}

.pagination {
  z-index: 0;
}

.nextPage {
  --slide-distance: 5%;
  composes: slideLeft from global;
}

.prevPage {
  --slide-distance: -5%;
  composes: slideRight from global;
}
